export class CatalogueVersionService {
  public catalogueVersionService: any = {};
  public catalogues = [];
  public resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.Catalogues.VersionsResponse>>;

  constructor($resource: ng.resource.IResourceService) {
    this.resource = $resource(
      'api/catalogues/:catalogueId/versions',
      undefined,
      {
        edit: { method: 'PATCH' }, update: { method: 'PUT' }
      });
  }

  public getCatalogue(catalogueId: string, version: number) {
    const options = {
      catalogueId: catalogueId,
      catalogueVersion: version
    };
    return this.resource.get(options).$promise;
  }

  public getList(catalogueId: string) {
    return this.resource.get({ catalogueId: catalogueId }).$promise.then((resource) => {
      return this.catalogues = resource.versions;
    });
  }

  public list() {
    return this.catalogues;
  }
}